import React, { useEffect, useState } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import {
	Button,
	Card,
	Form,
	Input,
	Space,
	Typography,
	Select,
	message,
	notification,
	Spin
} from 'antd';
import { withRouter, useHistory, Link } from 'react-router-dom';
import cookies from 'js-cookie';
import axiosConfig from '../../shared/utils/axios-config';
import './task-trigger.scss';

const TaskTrigger = () => {

	let history = useHistory();
	const [loading, setLoading] = useState(false);
	const tailLayout = {
		wrapperCol: {
			offset: 4,
			span: 12,
		},
	};

	const [processConfigs, setProcessConfigs] = useState([]);
	const [wizardCustomIdOptions, setWizardCustomIdOptions] = useState([]);

	const [form] = Form.useForm();
	const delay = (ms) => new Promise((res) => setTimeout(res, ms));
	const openNotificationWithIcon = (type, errorDetail) => {
		switch (type) {
			case 'success':
				notification[type]({
					message: 'Create setting successfully',
				});

				break;
			case 'error':
				notification[type]({
					message: 'Create setting fail',
					description: errorDetail,
				});
				break;
			default:
				break;
		}
	};

	const handleWizardCustomIdChange = async (e) => {

		console.log(e);

		if (!e) {
			return;
		}

		for (let index = 0; index < processConfigs.length; index++) {
			let config = processConfigs[index];
			let configProcessName = config.processName;
			let configTriggerName = config.triggerName;
			if (e != configTriggerName) continue;

			let configVariables = config.variables;
			if (configVariables && isJsonString(configVariables)) {
				let variables = [];
				let variablesJson = JSON.parse(configVariables);
				for (const [key, value] of Object.entries(variablesJson)) {
					console.log("Key", JSON.stringify(key));
					console.log("Value", JSON.stringify(value));
					let variable = {};
					variable.Name = value.Name;
					variables.push(variable);
				}
				form.setFieldsValue({
					"Variables": variables,  // <- set this specific field
				});
			}
			form.setFieldsValue(
				{
					"GroupName": configProcessName
				}
			)

		}

	}

	function isJsonString(str) {
		try {
			JSON.parse(str);
		} catch (e) {
			return false;
		}
		return true;
	}

	const fetchProcessConfigs = async () => {
		await axiosConfig({
			method: 'get',
			url: `/api/rpa/process-configs`,
			headers: {
				Authorization: `Bearer ${cookies.get('access_token')}`,
			},
		})
			.then((response) => {
				console.log(response);
				let configList = response.data.data;
				setProcessConfigs(configList);
				let newConfigs = configList.map((c) => {
					return { value: c.triggerName, label: c.triggerName };
				});
				setWizardCustomIdOptions(newConfigs);
			})
			.catch((error) => {
				if (error.response) {
					// The request was made and the server responded with a status code
					// that falls out of the range of 2xx
					console.log(error.response.data);
					console.log(error.response.status);
					console.log(error.response.headers);
				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					console.log(error.request);
				} else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error', error.message);
				}
				// setLoading(false);
				console.log(error.config);
			});
	};

	const onFinish = async (values) => {
		console.log("Trigger Task", JSON.stringify(values));
		setLoading(true);

		await axiosConfig({
			method: 'post',
			data: values,
			url: `/api/rpa/nintex/trigger-task`,
			headers: {
				Authorization: `Bearer ${cookies.get('access_token')}`,
			},
		})
			.then((response) => {
				console.log(response);
				history.push('/rpa/task-history');
			})
			.catch((error) => {
				if (error.response) {
					// The request was made and the server responded with a status code
					// that falls out of the range of 2xx
					console.log(error.response.data);
					console.log(error.response.status);
					console.log(error.response.headers);
				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					console.log(error.request);
				} else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error', error.message);
				}
				console.log(error.config);
			});
		setLoading(false);

	};

	const onReset = () => {
		form.resetFields();
	};

	const changePage = (page) => {
		switch (page) {
			case 'task-history':
				history.push('/rpa/task-history');
				break;
			default:
				break;
		}
	};

	useEffect(() => {
		document.title = 'Roxus | Task Trigger';
		fetchProcessConfigs();
	}, []);

	return (
		<>
			<div className='ocr-list-page'>
				<div className='ocr-title'>
					<span className='text'>TASK TRIGGER</span>
				</div>
			</div>
			<Spin spinning={loading}>
				<Form
					labelCol={{
						span: 4,
					}}
					wrapperCol={{
						span: 16,
					}}
					form={form}
					name='dynamic_form_complex'
					onFinish={onFinish}
					autoComplete='off'
					initialValues={{
						items: [{}],
					}}
				>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
						}}
					>
						<>
							<Form.Item
								label='Task Name'
								name='GroupName'
							>
								<Input />
							</Form.Item>
							<Form.Item
								className=''
								colon={false}
								name='wizardCustomId'
								rules={[
									{
										required: true,
										message: 'Wizard Custom ID is required',
									},
								]}
								label='Wizard Custom Id'>
								<Select
									placeholder="Select Wizard Custom Id"
									onChange={handleWizardCustomIdChange}
									options={wizardCustomIdOptions}
								/>
							</Form.Item>
							<Form.Item label='Environment' name='Environment'>
								<Select
									showSearch
									style={{
										width: 200,
									}}
									defaultValue="new"
									placeholder="Environment"
									options={[
										{
											value: 'new',
											label: '24.x.x',
										}
									]}
								/>
							</Form.Item>
							<Form.Item label='Queue Priority' name='priority' rules={[
								{
									required: true,
									message: 'Queue Priority is required',
								},
							]}>
								<Select
									showSearch
									style={{
										width: 200,
									}}
									placeholder="Priority"
									options={[
										{
											value: '1',
											label: '1',
										},
										{
											value: '2',
											label: '2',
										},
										{
											value: '3',
											label: '3',
										},
										{
											value: '4',
											label: '4',
										},
										{
											value: '5',
											label: '5',
										},
										{
											value: '6',
											label: '6',
										},
										{
											value: '7',
											label: '7',
										},
										{
											value: '8',
											label: '8',
										},
										{
											value: '9',
											label: '9',
										},
										{
											value: '10',
											label: '10',
										},
									]}
								/>
							</Form.Item>
							{/* Nest Form.List */}
							<Form.Item label='Variables'>
								<Form.List name={'Variables'}>
									{(subFields, subOpt) => (
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
											}}
										>
											{subFields.map((subField, index) => (
												<Space
													key={subField.key}
													style={{
														alignItems: 'unset',
													}}
												>
													<Form.Item
														name={[
															subField.name,
															'Name',
														]}
													>
														<Input
															placeholder={`Variable ${index + 1
																}`}
														/>
													</Form.Item>
													<Form.Item
														name={[
															subField.name,
															'Value',
														]}
														style={{
															width: '600px',
														}}
													>
														<Input
															placeholder={`Value ${index + 1
																}`}
														/>
													</Form.Item>
													<CloseOutlined
														style={{ color: '#ff4d4f' }}
														onClick={() => {
															subOpt.remove(
																subField.name
															);
														}}
													/>
												</Space>
											))}
											<Button
												type='dashed'
												onClick={() => subOpt.add()}
												block
											>
												+ Add New Variable
											</Button>
										</div>
									)}
								</Form.List>
							</Form.Item>
						</>
					</div>
					<Form.Item {...tailLayout}>
						<Button type='primary' htmlType='submit'>
							Trigger Task
						</Button>
						<Button htmlType='button' onClick={onReset}>
							Clear
						</Button>
						<Button
							htmlType='button'
							onClick={() => changePage('task-history')}
						>
							Go Back
						</Button>
					</Form.Item>
				</Form>
			</Spin>

		</>
	);
};

export default TaskTrigger;
